//------------------
// is spell changed
//------------------
export default function isSpellChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isSpellChanged')

  console.log('ORIGINAL SPELL: ', original)
  console.log('NOW SPELL: ', now)

  if (
    original.mag != now.mag ||
    original.character_item != now.character_item
  ) {
    console.log('VALUE CHANGED ', original.name)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.name)
    return false
  }
}
